import React from 'react';
import { useNavigate } from 'react-router-dom';
import SEO from './SEO';
import { Button } from 'react-bootstrap';

/**
 * 404 component
 * @returns {JSX.Element}
 */
export default function NotFound() {
    const navigate = useNavigate();
    return (<>
        <SEO
            seoTitle={'404 Not Found'}
            canonicalUrl={new URL('/404', process.env.APP_URL).toString()}
        />
        <div
            className={'loading-fallback'}>
            <div
                style={{ textAlign: 'center' }}>
                <h1>This page does not exist.</h1>
                <Button
                    onClick={() => navigate(-1)}>Go Back</Button>
            </div>
        </div>
    </>);
}